import { useQuery } from '@apollo/client';
import { graphql } from '@packages/charka-common-ui/graphql/types';

const QUERY = graphql(`
  query PageRuleData($id: ID!, $menuId: ID!) {
    menu(id: $menuId) {
      id
      companyId
      title
      allergics
      preferredProductPriceMode
      sections {
        ...MenuSectionItem
      }
      menuProducts {
        ...MenuProductItem
      }
    }
    printRule(id: $id) {
      id
      name
      printerDeviceId
      pages {
        id
        name
        printerDeviceId
        allowedSections {
          pageRuleId
          menuSectionId
          menuSection {
            code
            id
            name
          }
        }
      }
    }
  }
`);

export function useGetPageRuleData(id: string, menuId: string) {
  return useQuery(QUERY, {
    variables: {
      id,
      menuId
    },
  });
}
